import React from 'react'

function CustomizedWebsite() {
  return (
    <div>
      {/* Hero Start */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Customized Website Development</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/index">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Customized Websites</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Bluevipers Technology designs tailored websites that perfectly match your business goals. 
                We focus on responsive design, user experience, and scalable solutions for all industries.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Customized Website" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>
      {/* Hero End */}

      {/* Features Start */}
      <div className="container-fluid bg-dark feature pt-5">
        <div className="container pt-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-12 mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Bluevipers</div>
              <h1 className="text-white mb-4">Tailored Solutions for Your Unique Business Needs</h1>
              <p className="text-light mb-4">
                Customized websites allow your brand to stand out from the competition. At Bluevipers Technology, 
                we analyze your business requirements and deliver websites with custom designs, seamless navigation, 
                and advanced features. Whether it's an e-commerce portal, corporate website, or service platform, 
                we ensure your website is unique, fast, and fully optimized for search engines.
              </p>

              {/* Key Features */}
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Custom UI/UX design for your brand</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Responsive and mobile-friendly layouts</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Advanced features tailored to your business</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>SEO optimized and fast-loading websites</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Features End */}

      {/* Contact Start */}
      <div className="container-fluid bg-primary py-5">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Contact Us</div>
              <h1 className="text-white mb-4">Reach Bluevipers Technology Today</h1>
              <p className="text-white-50 mb-4">
                Call us at <strong>+91 8459432930</strong> or email at <strong>blueviperstechnology@gmail.com</strong> to discuss your project.
              </p>
              <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
    </div>
  )
}

export default CustomizedWebsite
